// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Help test Match con el snapshot 1`] = `
<div class="wrap-container container"><a href="https://www.bbva.com.ar/empresas.html">
        <div class="wrap-container text-container">
            <p>
                Si querés conocer más sobre nuestros productos para empresas<br>
                ingresá a <strong>bbva.com.ar/empresas</strong></p>
        </div>
    </a></div>
`;
